import { Component, ViewChild, OnInit } from '@angular/core';
import {MatCheckboxChange} from '@angular/material/checkbox';
import { DialogBoxComponent } from './dialog/dialog-box.component';
import { DialogBoxPrintComponentRiesgo } from './dialog/dialog-print-box.component';
import { MatTable } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { RiesgoService } from 'app/main/services/riesgo.service';
import { Riesgo } from 'app/main/models/riesgo.model';
import {SelectionModel} from '@angular/cdk/collections';
import { MatPaginator, PageEvent } from "@angular/material/paginator";

const ELEMENT_DATA: Riesgo[] = [];

@Component({
    selector   : 'riesgo',
    templateUrl: './riesgo.component.html',
    styleUrls  : ['./riesgo.component.scss']
})
export class RiesgoComponent
{
    displayedColumns: string[] = ['select','nombre','action'];
    dataSource = ELEMENT_DATA;
    selection = new SelectionModel<Riesgo>(true, []);
    basicSlice = 10;
    elementCount = 0;

    printElements = [];
    isAllItemsSelected = false;


    @ViewChild(MatTable, {static: true}) table: MatTable<any>;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    

    constructor(public dialog: MatDialog, private service: RiesgoService) {}

    ngOnInit() {
      
      this.paginator._intl.itemsPerPageLabel="Ítems por página";
      this.service.count().subscribe(req => {
        this.elementCount = req.body;
      });
      this.getElements(0);

    }

    getElements(page){
      this.getElementsByPageAndSize(page,this.basicSlice,'list');
    }

    getElementsByPageAndSize(page, size, type): void{
      this.service.getAll(page,size).pipe().subscribe(req => {
        var dataResponse = req.body.map( objetivo => {
          console.log(objetivo);
          return {
            id: objetivo.id,
            nombre: objetivo.nombre,
            bloqueado: objetivo.bloqueado
          };
        });

        dataResponse.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
        if(type=='list'){
          this.dataSource = dataResponse;
        }else{
          this.printElements = dataResponse;
          const dialogRef = this.dialog.open(DialogBoxPrintComponentRiesgo, {
            width: '100%',
            data: {action:"Print", obj: this.printElements},
            autoFocus: false,
            disableClose: true
          });
        }
      });
    }

    OnePageChange(event: PageEvent) {
      this.basicSlice = event.pageSize;
      this.getElements(event.pageIndex);
    }

    openDialog(action, obj): void {
      obj.action = action;
      const dialogRef = this.dialog.open(DialogBoxComponent, {
        width: '100%',
        autoFocus: false,
        data: {action:action, obj:obj,dataSource:this.dataSource},
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {

        if(result.dataSource!=null){
          this.dataSource = result.dataSource;
          this.dataSource.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
        }
        this.table.renderRows();
      });
    }

    print():void{
      
      if(this.isAllItemsSelected){
        this.getElementsByPageAndSize(0,10000,'printAll');
      }else{
        const dialogRef = this.dialog.open(DialogBoxPrintComponentRiesgo, {
          width: '100%',
          data: {action:"Print", obj:this.selection.selected},
          autoFocus: false,
          disableClose: true
        });
      }
    }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle(event:MatCheckboxChange) {
    this.isAllItemsSelected = event.checked;
    !this.isAllItemsSelected  ?
        this.selection.clear() :
        this.dataSource.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: Riesgo): string {
    if (!row) {
      return `${this.isAllItemsSelected ? 'select' : 'deselect'} all`;
    }
    //return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row`;
  }

}
